import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import homeNo from './locales/no/home.json';
import homeEn from './locales/en/home.json';
import productsNo from './locales/no/products.json';
import productsEn from './locales/en/products.json';
import mycartNo from './locales/no/mycart.json';
import mycartEn from './locales/en/mycart.json';
import paymentReturnNo from './locales/no/paymentReturn.json';
import paymentReturnEn from './locales/en/paymentReturn.json';
import supportNo from './locales/no/support.json';
import supportEn from './locales/en/support.json';
import privacyNo from './locales/no/privacy.json';
import privacyEn from './locales/en/privacy.json';
import ticketsNo from './locales/no/tickets.json';
import ticketsEn from './locales/en/tickets.json';
import couponsNo from './locales/no/coupons.json';
import couponsEn from './locales/en/coupons.json';
import ordersNo from './locales/no/orders.json';
import ordersEn from './locales/en/orders.json';
import settingsNo from './locales/no/settings.json';
import settingsEn from './locales/en/settings.json';
import commonNo from './locales/no/common.json';
import commonEn from './locales/en/common.json';
import profileNo from './locales/no/profile.json';
import profileEn from './locales/en/profile.json';
import loginNo from './locales/no/login.json';
import loginEn from './locales/en/login.json';
import createUserNo from './locales/no/createUser.json';
import createUserEn from './locales/en/createUser.json';
import forgotPasswordNo from './locales/no/forgotPassword.json';
import forgotPasswordEn from './locales/en/forgotPassword.json';
import emailVerificationNo from './locales/no/emailVerification.json';
import emailVerificationEn from './locales/en/emailVerification.json';
import authActionNo from './locales/no/authAction.json';
import authActionEn from './locales/en/authAction.json';
import klippekortRedeemNo from './locales/no/klippekortRedeem.json';
import klippekortRedeemEn from './locales/en/klippekortRedeem.json';
import qrModalNo from './locales/no/qrModal.json';
import qrModalEn from './locales/en/qrModal.json';
import ticketDetailsModalNo from './locales/no/ticketDetailsModal.json';
import ticketDetailsModalEn from './locales/en/ticketDetailsModal.json';
import navbarNo from './locales/no/navbar.json';
import navbarEn from './locales/en/navbar.json';
import pageHeaderNo from './locales/no/pageHeader.json';
import pageHeaderEn from './locales/en/pageHeader.json';
import systemStateNo from './locales/no/systemState.json';
import systemStateEn from './locales/en/systemState.json';

// One namespace file pair per page, added here as each page gets translated -
// avoids one giant inline resources object as the app-wide rollout grows.
const resources = {
  no: {
    home: homeNo,
    products: productsNo,
    mycart: mycartNo,
    paymentReturn: paymentReturnNo,
    support: supportNo,
    privacy: privacyNo,
    tickets: ticketsNo,
    coupons: couponsNo,
    orders: ordersNo,
    settings: settingsNo,
    common: commonNo,
    profile: profileNo,
    login: loginNo,
    createUser: createUserNo,
    forgotPassword: forgotPasswordNo,
    emailVerification: emailVerificationNo,
    authAction: authActionNo,
    klippekortRedeem: klippekortRedeemNo,
    qrModal: qrModalNo,
    ticketDetailsModal: ticketDetailsModalNo,
    navbar: navbarNo,
    pageHeader: pageHeaderNo,
    systemState: systemStateNo,
  },
  en: {
    home: homeEn,
    products: productsEn,
    mycart: mycartEn,
    paymentReturn: paymentReturnEn,
    support: supportEn,
    privacy: privacyEn,
    tickets: ticketsEn,
    coupons: couponsEn,
    orders: ordersEn,
    settings: settingsEn,
    common: commonEn,
    profile: profileEn,
    login: loginEn,
    createUser: createUserEn,
    forgotPassword: forgotPasswordEn,
    emailVerification: emailVerificationEn,
    authAction: authActionEn,
    klippekortRedeem: klippekortRedeemEn,
    qrModal: qrModalEn,
    ticketDetailsModal: ticketDetailsModalEn,
    navbar: navbarEn,
    pageHeader: pageHeaderEn,
    systemState: systemStateEn,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'no',
    fallbackLng: 'no',
    ns: ['home', 'products', 'mycart', 'paymentReturn', 'support', 'privacy', 'tickets', 'coupons', 'orders', 'settings', 'common', 'profile', 'login', 'createUser', 'forgotPassword', 'emailVerification', 'authAction', 'klippekortRedeem', 'qrModal', 'ticketDetailsModal', 'navbar', 'pageHeader', 'systemState'],
    defaultNS: 'home',
    interpolation: { escapeValue: false },
  });

export default i18n;
